module.exports = __webpack_public_path__ + "img/cladire3.b06bb09e.jpeg";